// Derived from https://stackoverflow.com/a/30810322/1176156
// Note: The original answer includes some additional styling protection to keep the textarea from displaying
// We may or may not need that.
export const copyTextToClipboard = (text: string): boolean => {
  const textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.select()

  let success = false
  try {
    success = document.execCommand('copy')
  } catch {
    console.warn('Unable to copy text to clipboard')
  } finally {
    document.body.removeChild(textArea)
    return success
  }
}
